export default __webpack_public_path__ + "static/media/priya.5eee23d8.png";